import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import EmailSenderService from "services/EmailSenderService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getEmailSenderApi = createAsyncThunk(
  "emailSender/getEmailSenderApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await EmailSenderService.getEmailSender(data ?? {});
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const addEmailSenderApi = createAsyncThunk(
  "emailSender/addEmailSenderApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await EmailSenderService.createEmailSender(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateEmailSenderApi = createAsyncThunk(
  "emailSender/updateEmailSenderApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await EmailSenderService.updateEmailSender(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const delEmailSenderApi = createAsyncThunk(
  "emailSender/delEmailSenderApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;

      const response = await EmailSenderService.delEmailSender(id);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,

  emailSenderList: [],
  
  currentRequestId: undefined,
};

export const emailSenderSlice = createSlice({
  name: "emailSender",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setEmailSenderList: (state, action) => {
      state.emailSenderList = action.payload || [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEmailSenderApi.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getEmailSenderApi.fulfilled, (state, action) => {
        state.loading = false;
        state.emailSenderList = action.payload ?? [];
      })
      .addCase(getEmailSenderApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(addEmailSenderApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(addEmailSenderApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addEmailSenderApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateEmailSenderApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateEmailSenderApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateEmailSenderApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(delEmailSenderApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(delEmailSenderApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(delEmailSenderApi.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setEmailSenderList } = emailSenderSlice.actions;

export default emailSenderSlice.reducer;